var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.799,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.492,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4214,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.1371,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0661,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7107,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.429,
    x2: 439.82,
    y2: 8.6447,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3554,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4975,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.801 112.389C113.026 112.389 111.371 112.097 109.835 111.513C108.32 110.907 106.989 110.063 105.842 108.981C104.696 107.9 103.798 106.634 103.149 105.184C102.521 103.713 102.207 102.122 102.207 100.413C102.207 98.6817 102.521 97.0913 103.149 95.6416C103.798 94.1918 104.685 92.9368 105.81 91.8766C106.957 90.8163 108.288 89.994 109.802 89.4098C111.317 88.8039 112.961 88.501 114.736 88.501C116.532 88.501 118.176 88.7823 119.669 89.3449C121.162 89.9075 122.461 90.6865 123.564 91.6818L119.247 96.0311C118.728 95.4685 118.09 95.0249 117.332 94.7003C116.597 94.3758 115.731 94.2135 114.736 94.2135C113.87 94.2135 113.07 94.3541 112.334 94.6354C111.62 94.9167 111.003 95.3278 110.484 95.8688C109.965 96.4097 109.553 97.0697 109.25 97.8487C108.969 98.606 108.829 99.4607 108.829 100.413C108.829 101.386 108.969 102.263 109.25 103.042C109.553 103.799 109.965 104.448 110.484 104.989C111.003 105.53 111.62 105.952 112.334 106.255C113.07 106.536 113.87 106.677 114.736 106.677C115.709 106.677 116.575 106.526 117.332 106.223C118.111 105.92 118.782 105.476 119.345 104.892L123.694 109.241C122.547 110.236 121.26 111.015 119.832 111.578C118.403 112.119 116.726 112.389 114.801 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.947 112.389C134.913 112.389 133.138 111.978 131.624 111.156C130.109 110.312 128.93 109.155 128.086 107.683C127.242 106.212 126.82 104.524 126.82 102.62V88.8905H133.311V103.204C133.311 103.94 133.474 104.567 133.798 105.087C134.123 105.606 134.556 106.006 135.097 106.288C135.659 106.547 136.276 106.677 136.947 106.677C137.639 106.677 138.245 106.547 138.764 106.288C139.305 106.006 139.727 105.617 140.03 105.119C140.333 104.6 140.484 103.972 140.484 103.237V88.8905H147.008V102.652C147.008 104.556 146.586 106.244 145.742 107.716C144.92 109.165 143.752 110.312 142.237 111.156C140.744 111.978 138.981 112.389 136.947 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.922 112.389C156.953 112.389 155.233 112.108 153.761 111.546C152.311 110.961 150.97 110.042 149.736 108.787L153.794 104.73C154.637 105.53 155.525 106.147 156.455 106.58C157.386 106.991 158.381 107.196 159.441 107.196C160.328 107.196 160.999 107.066 161.453 106.807C161.908 106.526 162.135 106.147 162.135 105.671C162.135 105.195 161.94 104.805 161.551 104.502C161.161 104.178 160.642 103.897 159.993 103.658C159.365 103.399 158.662 103.139 157.883 102.88C157.126 102.62 156.369 102.306 155.611 101.938C154.854 101.57 154.151 101.127 153.501 100.608C152.874 100.067 152.365 99.4066 151.976 98.6276C151.587 97.827 151.392 96.8533 151.392 95.7065C151.392 94.2135 151.749 92.926 152.463 91.8441C153.177 90.7622 154.183 89.9399 155.481 89.3774C156.78 88.7931 158.305 88.501 160.058 88.501C161.789 88.501 163.39 88.7823 164.861 89.3449C166.355 89.8858 167.588 90.6648 168.562 91.6818L164.472 95.739C163.758 95.0465 163.044 94.538 162.33 94.2135C161.616 93.8673 160.837 93.6942 159.993 93.6942C159.322 93.6942 158.781 93.8023 158.37 94.0187C157.981 94.2351 157.786 94.5597 157.786 94.9924C157.786 95.4468 157.981 95.8255 158.37 96.1284C158.76 96.4097 159.268 96.6694 159.896 96.9074C160.545 97.1454 161.248 97.3943 162.005 97.6539C162.784 97.9136 163.552 98.2273 164.31 98.5952C165.067 98.9414 165.759 99.3958 166.387 99.9584C167.036 100.499 167.555 101.181 167.945 102.003C168.334 102.825 168.529 103.821 168.529 104.989C168.529 107.348 167.685 109.176 165.997 110.474C164.331 111.751 161.973 112.389 158.922 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.322 112V88.8905H183.814V112H177.322ZM170.409 94.4082V88.8905H190.759V94.4082H170.409Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.004 112.454C203.186 112.454 201.509 112.151 199.973 111.546C198.458 110.94 197.127 110.096 195.981 109.014C194.855 107.932 193.979 106.655 193.351 105.184C192.724 103.713 192.41 102.122 192.41 100.413C192.41 98.6817 192.713 97.0913 193.319 95.6416C193.947 94.1918 194.823 92.926 195.948 91.8441C197.073 90.7622 198.393 89.9291 199.908 89.3449C201.444 88.739 203.121 88.4361 204.939 88.4361C206.756 88.4361 208.422 88.739 209.937 89.3449C211.473 89.9291 212.804 90.7622 213.929 91.8441C215.055 92.926 215.92 94.2026 216.526 95.674C217.153 97.1238 217.467 98.7142 217.467 100.445C217.467 102.155 217.153 103.745 216.526 105.216C215.92 106.666 215.055 107.943 213.929 109.046C212.804 110.128 211.484 110.972 209.97 111.578C208.455 112.162 206.8 112.454 205.004 112.454ZM204.939 106.742C206.15 106.742 207.2 106.482 208.087 105.963C208.974 105.444 209.656 104.708 210.132 103.756C210.608 102.804 210.846 101.689 210.846 100.413C210.846 99.4607 210.705 98.606 210.424 97.8487C210.164 97.0697 209.775 96.4097 209.256 95.8688C208.736 95.3062 208.109 94.8842 207.373 94.603C206.659 94.3 205.847 94.1486 204.939 94.1486C203.727 94.1486 202.678 94.4082 201.79 94.9275C200.903 95.4252 200.222 96.1501 199.746 97.1022C199.27 98.0326 199.031 99.1361 199.031 100.413C199.031 101.386 199.161 102.263 199.421 103.042C199.702 103.821 200.103 104.492 200.622 105.054C201.141 105.595 201.758 106.017 202.472 106.32C203.208 106.601 204.03 106.742 204.939 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.439 112V88.8905H226.145L234.746 101.484H232.701L241.27 88.8905H245.976V112H239.55V99.5364L240.491 99.7961L235.785 106.547H231.63L226.956 99.7961L227.865 99.5364V112H221.439Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.577 112L270.602 88.8905H275.665L271.608 112H266.577ZM257.197 105.736V101.516H276.477V105.736H257.197ZM258.95 112L263.007 88.8905H268.005L264.013 112H258.95ZM258.365 98.8873V94.7003H277.613V98.8873H258.365Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.181 112.389C286.537 112.389 285 112.119 283.572 111.578C282.166 111.015 280.976 110.226 280.002 109.209L284.059 105.216C284.427 105.736 284.99 106.169 285.747 106.515C286.504 106.839 287.283 107.002 288.084 107.002C288.733 107.002 289.306 106.893 289.804 106.677C290.323 106.461 290.724 106.147 291.005 105.736C291.308 105.325 291.459 104.827 291.459 104.243C291.459 103.658 291.308 103.161 291.005 102.75C290.702 102.339 290.269 102.025 289.707 101.808C289.144 101.592 288.473 101.484 287.694 101.484C287.262 101.484 286.796 101.516 286.299 101.581C285.823 101.625 285.455 101.7 285.195 101.808L288.019 98.3031C288.776 98.13 289.447 97.9893 290.031 97.8811C290.637 97.7513 291.167 97.6864 291.622 97.6864C292.79 97.6864 293.839 97.9569 294.77 98.4978C295.7 99.0388 296.436 99.8177 296.977 100.835C297.518 101.83 297.788 103.02 297.788 104.405C297.788 105.985 297.388 107.38 296.588 108.592C295.809 109.782 294.694 110.713 293.244 111.383C291.816 112.054 290.129 112.389 288.181 112.389ZM285.195 101.808V98.3355L290.291 92.331L297.204 92.3634L291.946 98.3031L285.195 101.808ZM281.722 94.2135V88.8905H297.204V92.3634L292.433 94.2135H281.722Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock3);
export default __webpack_public_path__ + "static/media/custom-block-3.83bb4f119a7565b512cc99ae08eb8402.svg";
export { ForwardRef as ReactComponent };